import React from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@/components/Box';
import ExtendedRegions from '@/components/SearchRequestFilter/ExtendedRegions';

import SelectedRegionsStockholm from './SelectedRegionsStockholm';
import {
  Container,
  FilterProps,
  Label,
  RegionProps,
  StyledTag,
} from './shared';
import { getCityId, isStockholm } from './util';

function Regions({
  searchRequestSettings,
  setSearchRequestSettings,
  regions,
  label = true,
}: FilterProps & RegionProps): React.ReactElement {
  const { t } = useTranslation();
  return (
    <div style={{ width: '100%' }}>
      {label && <Label>{t('county')}</Label>}
      <Container>
        {regions.map(({ name, id, children }) => {
          const childrenIds = children?.map(child => child.id);

          const isChecked =
            searchRequestSettings.regionIds.includes(id) ||
            searchRequestSettings.regionIds.includes(getCityId(id)) ||
            searchRequestSettings.regionIds.some(id =>
              childrenIds.includes(id),
            );

          return (
            <>
              <StyledTag
                key={id}
                $checkedStockholm={isStockholm(id) && isChecked}
                checked={isChecked}
                onChange={checked => {
                  const { regionIds } = searchRequestSettings;
                  const next = checked
                    ? [...regionIds, id]
                    : regionIds.filter(regionId => {
                        if (children.length > 0) {
                          return (
                            !childrenIds.includes(regionId) &&
                            regionId !== id &&
                            regionId !== getCityId(id)
                          );
                        }
                        return regionId !== id;
                      });
                  setSearchRequestSettings({
                    ...searchRequestSettings,
                    regionIds: next,
                  });
                }}
                $centered
              >
                <Box flex alignItems={'center'}>
                  <Box horizontalSpacing={1}>{name} </Box>
                </Box>
              </StyledTag>
              {isStockholm(id) && isChecked && (
                <SelectedRegionsStockholm
                  searchRequestSettings={searchRequestSettings}
                  setSearchRequestSettings={setSearchRequestSettings}
                  regions={children}
                />
              )}
              {!isStockholm(id) && isChecked && children.length > 0 && (
                <ExtendedRegions
                  searchRequestSettings={searchRequestSettings}
                  setSearchRequestSettings={setSearchRequestSettings}
                  regions={children}
                  parentId={id}
                  cityId={getCityId(id)}
                />
              )}
            </>
          );
        })}
      </Container>
    </div>
  );
}

export default Regions;
